const buildChatWhatsappMessage = (input) => {
  const text = input.trim();
  if (!text) {
    return "Olá! Vim pelo BezierBot e quero falar sobre desenvolvimento web B2B para a minha empresa.";
  }
  return `Olá! Vim pelo BezierBot e quero falar sobre este projeto: ${text}`;
};

module.exports = {
  buildChatWhatsappMessage,
};
